<template>
  <b-row>
    <b-col cols="12">
      <BeritaKegiatan />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import BeritaKegiatan from "../web/BeritaKegiatanTable.vue";

export default {
  components: {
    BRow,
    BCol,

    BeritaKegiatan,
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/quill.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
